// extracted by mini-css-extract-plugin
export default {"title":"AddSectionPopup_title__A80OB","tableWrap":"AddSectionPopup_tableWrap__AsBEk","action":"AddSectionPopup_action__uWim+"};